import { useState } from "react";
import { toast } from "sonner";
import { ArrowRight } from "lucide-react";
import { subscribeNewsletter } from "../lib/api";

export default function NewsletterForm({ variant = "inline", source = "website" }) {
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email || !email.includes("@")) {
      toast.error("Drop a real email — we don't spam.");
      return;
    }
    setLoading(true);
    try {
      const res = await subscribeNewsletter({ email, name, source });
      if (res.already_subscribed) {
        toast.success("You're already on the list. Welcome back.");
      } else {
        toast.success("You're in. First edition hits Monday.");
      }
      setEmail(""); setName("");
    } catch (err) {
      toast.error("Couldn't sign you up. Try again?");
    } finally { setLoading(false); }
  };

  if (variant === "stacked") {
    return (
      <form onSubmit={submit} className="space-y-4" data-testid="newsletter-form-stacked">
        <div>
          <label className="text-kicker block mb-1">First Name (optional)</label>
          <input type="text" className="field" placeholder="Your name"
                 value={name} onChange={(e) => setName(e.target.value)}
                 data-testid="newsletter-name-input" />
        </div>
        <div>
          <label className="text-kicker block mb-1">Email</label>
          <input type="email" className="field" placeholder="you@example.com" required
                 value={email} onChange={(e) => setEmail(e.target.value)}
                 data-testid="newsletter-email-input" />
        </div>
        <button className="btn-rust w-full justify-center" type="submit" disabled={loading}
                data-testid="newsletter-submit-button">
          {loading ? "Signing you up…" : "Join the Huddle"} <ArrowRight size={16} />
        </button>
      </form>
    );
  }

  return (
    <form onSubmit={submit} className="flex flex-col sm:flex-row gap-3 items-stretch" data-testid="newsletter-form-inline">
      <input type="email" className="field flex-1 bg-[var(--paper)] px-4 py-3 border-2 border-[var(--ink)]"
             placeholder="you@example.com" required
             value={email} onChange={(e) => setEmail(e.target.value)}
             data-testid="newsletter-inline-email-input" />
      <button className="btn-rust" type="submit" disabled={loading}
              data-testid="newsletter-inline-submit-button">
        {loading ? "Working…" : "Sign Up"} <ArrowRight size={16} />
      </button>
    </form>
  );
}
